var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5967_44774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.087 15.0781C115.415 14.9367 115.78 14.882 116.136 14.9185C116.492 14.9595 116.834 15.0873 117.126 15.3017C118.632 16.4011 118.55 16.8482 119.576 18.2853L120.552 19.6995L121.009 20.3702C121.273 20.7534 121.401 21.2187 121.378 21.6841C121.355 22.1494 121.177 22.5965 120.872 22.9478L120.648 23.1759L117.893 25.2242C117.76 25.32 117.664 25.4615 117.628 25.6211C117.592 25.7808 117.614 25.9496 117.692 26.091C118.317 27.227 120.698 29.9415 121.971 31.2143C123.244 32.4871 127.176 35.5072 128.385 36.2007C128.65 36.3512 128.965 36.301 129.179 36.1094L129.293 35.9771L131.086 33.2444C131.415 32.8065 131.903 32.5099 132.441 32.4232C132.984 32.3366 133.536 32.4597 133.988 32.7745L135.502 33.9926C136.15 34.6587 137.272 35.4935 137.834 36.0182C138.062 36.3102 138.208 36.6614 138.253 37.031C138.299 37.4005 138.249 37.7746 138.098 38.1167C136.917 40.8723 135.735 41.187 132.624 41.073L132.149 41.0411L131.415 40.9726L130.548 40.8266C127.792 40.3066 123.372 38.7418 118.791 34.166C114.216 29.5856 112.651 25.1649 112.131 22.4094L112.012 21.6977L111.939 21.0773L111.903 20.5572C111.898 20.4842 111.893 20.4067 111.889 20.3337C111.775 17.2178 112.322 16.2597 115.087 15.0781Z",
    fill: "#60A5FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.008 27.53C151.008 41.8505 139.397 53.461 125.072 53.461C120.944 53.461 117.043 52.4984 113.58 50.7831L100.752 54.4054L104.082 42.7583C100.971 38.4836 99.1367 33.2235 99.1367 27.53C99.1367 13.205 110.752 1.59448 125.072 1.59448C139.393 1.59448 151.008 13.205 151.008 27.53Z",
    stroke: "#60A5FA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5967_44774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.c03d26c9e166724d4958579dcb1c6635.svg";
export { ForwardRef as ReactComponent };